import {configureStore} from '@reduxjs/toolkit';
import passwordIssueReducer from './features/passwordIssue/passwordIssue.slice';
import modalReducer from './features/modal/modal.slice';
import paramReducer from './features/param/param.slice';
import selectReducer from './features/select/select.slice';
import appReducer from './features/apps/app.slice';

export default configureStore({
    reducer: {
        passwordIssue: passwordIssueReducer,
        modal: modalReducer,
        param: paramReducer,
        select: selectReducer,
        app: appReducer
    }
});
